import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateService } from '../date.service';
import { Moment } from 'moment/moment';

@Pipe({
  name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {

  constructor(
    private translate: TranslateService,
    private date: DateService) {}

  transform(date: Moment, format: string): string {
    if (!date || !date.isValid()) {
      return this.translate.instant('pipe.fulldate.error');
    }
    return date.format(format);
  }

}
